import React, { useContext, useState } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, Form, FormGroup } from "src/style";
import { RiCloseFill } from "react-icons/ri";

export const ProfileUpdate: React.FC<any> = ({close}) => {
    const {info: {userData}} = useContext(AppInfoContext)
    const [input, setInput] = useState({
        fullName: userData?.fullName || '', 
        email: userData?.email || '', 
        username: userData?.username || ''
    })

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        close()
    }
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Edit Profile</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Full name</label>
                        <input 
                            placeholder="Enter full name" 
                            name='fullName'
                            value={input.fullName}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label>Email</label>
                        <input 
                            placeholder="Enter email" 
                            name='email'
                            value={input.email}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label>Username</label>
                        <input 
                            placeholder="Enter username" 
                            name='username'
                            value={input.username}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 

                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='12.9'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Save changes
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}